import { defineMessages } from 'react-intl'

export const dateRangePickerMessages = defineMessages({
  allPeriod: {
    id: 'dateRangePicker.dateRangePickerPlaceholder',
    description: 'dateRangePicker placeholder',
    defaultMessage: 'All Period',
  },
})
